import { guideSteps } from "@/mocks/home";
import Reveal from "@/pages/home/components/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function GuideSteps() {
  return (
    <section id="guide" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <Reveal>
        <SectionHeading
          tag="进入步骤"
          title="六步找到并稳定进入官网入口"
          desc="从确认入口到留存备用方式，把这套流程走一遍，下次遇到地址变化也能自己快速处理，不必反复搜索。"
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {guideSteps.map((step, idx) => (
          <Reveal key={step.no} delay={idx * 60}>
            <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:border-primary-300 transition-colors">
              <div className="flex items-center justify-between">
                <span className="font-heading font-black text-3xl text-primary-200">{step.no}</span>
                <span className="w-9 h-9 rounded-full bg-background-100 text-foreground-700 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </div>
              <h3 className="mt-4 font-heading font-bold text-foreground-950 text-base">
                {step.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={80}>
        <div className="mt-8 rounded-lg bg-foreground-950 text-background-50 p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
          <span className="w-12 h-12 rounded-md bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
            <i className="ri-timer-flash-line text-2xl"></i>
          </span>
          <div className="flex-1">
            <h3 className="font-heading font-bold text-base">省时间提示</h3>
            <p className="mt-1 text-sm text-background-200 leading-relaxed">
              如果你只是想马上打开看一眼，最省事的顺序是：先确认入口 → 核对域名 → 选网页版直接浏览。
              需要长期使用再考虑安装 APP，不必一上来就下载安装包。
            </p>
          </div>
        </div>
      </Reveal>
    </section>
  );
}